import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, PhoneOff, User } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export default function IncomingCallModal({ callData, onAnswer, onDecline }) {
  const [isRinging, setIsRinging] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Play ring sound (optional)
    // const audio = new Audio('/ring.mp3');
    // audio.loop = true;
    // audio.play();
    
    return () => {
      // audio.pause();
    };
  }, []);

  const handleAnswer = () => {
    setIsRinging(false);
    if (onAnswer) {
      onAnswer();
    }
    // Navigate to incoming video call page with session_id
    navigate(`/family/incoming-call/${callData.session_id}`);
  };

  const handleDecline = () => {
    setIsRinging(false);
    if (onDecline) {
      onDecline();
    }
  };

  if (!isRinging) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-md z-[100] flex items-center justify-center p-6 animate-in fade-in duration-300">
      <Card className="bg-gradient-to-br from-[#1a1f3a] to-[#0f1425] border-violet-500/30 max-w-md w-full shadow-2xl animate-in zoom-in duration-300">
        <CardContent className="pt-12 pb-12">
          {/* Avatar/Icon */}
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="w-32 h-32 rounded-full bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center animate-pulse">
                <User className="w-20 h-20 text-white" strokeWidth={2} />
              </div>
              {/* Pulse Rings */}
              <div className="absolute inset-0 w-32 h-32 rounded-full border-4 border-violet-400 animate-ping opacity-20"></div>
              <div className="absolute inset-0 w-32 h-32 rounded-full border-4 border-violet-400 animate-ping opacity-10" style={{ animationDelay: '0.5s' }}></div>
            </div>
          </div>

          {/* Caller Info */}
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-white mb-2">
              {callData.senior_name || 'Senior'}
            </h2>
            <p className="text-xl text-gray-400">
              Eingehender Anruf...
            </p>
            {callData.call_type === 'dropin' && (
              <div className="mt-4 px-4 py-2 bg-purple-500/20 rounded-lg inline-block">
                <p className="text-purple-300 text-sm font-semibold">
                  🎥 Drop-In Anruf
                </p>
              </div>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex gap-6 justify-center">
            {/* Decline */}
            <button
              onClick={handleDecline}
              className="w-20 h-20 rounded-full bg-red-500 hover:bg-red-600 active:scale-95 transition-all shadow-lg flex items-center justify-center group"
              aria-label="Ablehnen"
            >
              <PhoneOff className="w-10 h-10 text-white group-hover:rotate-12 transition-transform" strokeWidth={2.5} />
            </button>

            {/* Answer */}
            <button
              onClick={handleAnswer}
              className="w-20 h-20 rounded-full bg-green-500 hover:bg-green-600 active:scale-95 transition-all shadow-lg flex items-center justify-center group animate-bounce"
              aria-label="Annehmen"
            >
              <Phone className="w-10 h-10 text-white group-hover:-rotate-12 transition-transform" strokeWidth={2.5} />
            </button>
          </div>

          {/* Helper Text */}
          <p className="text-center text-gray-500 text-sm mt-8">
            Tippen Sie auf den grünen Button um anzunehmen
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
